/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".map-filter-line[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.map-filter-line[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-right:5px}i.map-filter-on[_ngcontent-%COMP%]{color:#fff}\n/*# sourceMappingURL=feat-map-filter.component.css.map*/"];
export { styles as styles };
